import { LineChart, LineChartDataSet as DataSet } from '@round/whitelabel-ui';
import { numberWithCommas } from 'helpers';
import styles from './CreationsCharts.module.css';
import { Tooltip } from '@round/whitelabel-ui';
import moment from 'moment';
import { Card } from '@round/whitelabel-ui';

export type Data = {
    totals: DataSet;
    daily: DataSet;
};

export type Props = {
    data: Data;
    isLoading: boolean;
    hasError: boolean;
};

const CreationsCharts = ({ data, isLoading, hasError }: Props) => {
    return (
        <div className={styles.container}>
            <Card>
                <p className={styles.title}>Total Creations</p>
                <div className={styles.chartContainer}>
                    <LineChart
                        isLoading={isLoading}
                        hasError={hasError}
                        dataSets={[data.totals]}
                        renderTooltip={({ point }) => (
                            <>
                                <Tooltip.Title>{moment(point.x).format('D MMM YYYY')}</Tooltip.Title>
                                <Tooltip.Body>
                                    <dl className={styles.tooltipStats}>
                                        <div className={styles.tooltipStatsItem}>
                                            <dt>Total Creations</dt>
                                            <dd>{numberWithCommas(point.y)}</dd>
                                        </div>
                                    </dl>
                                </Tooltip.Body>
                            </>
                        )}
                    />
                </div>
            </Card>

            <Card>
                <p className={styles.title}>Daily Creations</p>
                <div className={styles.chartContainer}>
                    <LineChart
                        isLoading={isLoading}
                        hasError={hasError}
                        dataSets={[data.daily]}
                        renderTooltip={({ point }) => (
                            <>
                                <Tooltip.Title>{moment(point.x).format('D MMM YYYY')}</Tooltip.Title>
                                <Tooltip.Body>
                                    <dl className={styles.tooltipStats}>
                                        <div className={styles.tooltipStatsItem}>
                                            <dt>Daily Creations</dt>
                                            <dd>{numberWithCommas(point.y)}</dd>
                                        </div>
                                    </dl>
                                </Tooltip.Body>
                            </>
                        )}
                    />
                </div>
            </Card>
        </div>
    );
};

export default CreationsCharts;
